import {
  OPT_IN_NEVER,
  suggestPicto,
  type HiddenPictos,
  type PictoKeywords,
} from '@amumin/domain/pictoSuggest';

// Pictogram voorstellen bij een titel: de regels staan in het domein (@amumin/domain/pictoSuggest),
// zodat de ouderapp en de plusknop op het bord hetzelfde voorstellen.
export { OPT_IN_NEVER, suggestPicto, type HiddenPictos, type PictoKeywords };

/**
 * Pictogram voor een sjabloon: het opgeslagen icoon als dat een pictogram uit de set is (dan
 * toont de tegel precies wat de taak krijgt, 0009_template_icons); anders (sprint-1-id of leeg)
 * het voorstel uit de naam.
 */
export function templateIcon(
  name: string,
  icon: string | null | undefined,
  names: Readonly<Record<string, string>>,
  keywords: PictoKeywords = {},
  hidden: HiddenPictos = OPT_IN_NEVER,
): string | null {
  if (icon && Object.prototype.hasOwnProperty.call(names, icon)) return icon;
  return suggestPicto(name, names, [], keywords, hidden) ?? icon ?? null;
}
